import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Modal,
  Tooltip,
  IconButton,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import Clear from "@mui/icons-material/Clear";
import { IS_TEST_SERVER } from "../App";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    closeIcon:{
    },
    closeButton:{
    },
    titleBar: {
      flexGrow: 1,
    },
    toolBar: {
      background: (!IS_TEST_SERVER)?theme.palette.primary.main:theme.palette.QA.main,
    },
    appBar: {
      zIndex: 100000,
      backgroundColor: (!IS_TEST_SERVER)?theme.palette.primary.main:theme.palette.QA.main,
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(0,0,0),
        width:'CALC(100% - 20px)',
        overflowY: 'scroll',
        height:'CALC(100% - 20px)',
    },
    content: {
      padding: theme.spacing(1,1,1),
      margin: theme.spacing(1,1,1),
      position: 'absolute',
      height:'CALC(100% - 60px)',
      width:'CALC(100% - 20px)',
    }
  })
);
export default function PageInPage(props:{onClose?:Function,isOpen:boolean,content:React.ReactElement<any>,title:string}) {
  const classes = useStyles();
  const theme = useTheme();
  const handleClose = () => {if(props.onClose){props.onClose()}}
  return (
        <Modal className={classes.modal}
          open={props.isOpen}
          onClose={handleClose}
        >
          <div className={classes.paper}>
            <AppBar position="sticky" className={classes.appBar} enableColorOnDark>
              <Toolbar className={classes.toolBar}>
                <Typography
                  variant="h6"
                  className={classes.titleBar}
                  noWrap
                >
                  {props.title}
                </Typography>
                <div style={{ paddingRight: "5px", textAlign:"right"}}>
                  <Tooltip title={"Close"}>
                    <IconButton onClick={handleClose} className={classes.closeButton} >
                        <Clear className={classes.closeIcon} />
                    </IconButton>
                  </Tooltip>
                </div>
              </Toolbar>
            </AppBar>
          <div className={classes.content}>
              {props.content}
            </div>
          </div>
        </Modal>
  );
}